import { RootState } from '@/store/main';

export const selectSeriesList = (state: RootState) => state.series.seriesList;
export const selectCurrentSeries = (state: RootState) => state.series.currentSeries;
export const selectIsLoadingSeriesList = (state: RootState) => state.series.loadingSeriesList;
export const selectIsLoadingCurrentSeries = (state: RootState) => state.series.loadingCurrentSeries;
export const selectSeriesError = (state: RootState) => state.series.seriesError;
export const selectTopDrawerOpen = (state: RootState) => state.series.topDrawerOpen;
export const selectTotalSeries = (state: RootState) => state.series.totalSeries;
export const selectSeriesInitiallyLoaded = (state: RootState) => state.series.seriesListInitialLoaded;
export const selectSeriesHasProjects = (state: RootState) => state.series.seriesHasProjects;
